import React from 'react';

interface Props {
	children: React.ReactElement;
}

export const WidgetList = (props: Props): React.ReactElement => {
	const { children } = props;

	return <ul className="ui-widget-list">{children}</ul>;
};
